import { render, staticRenderFns } from "./aboutCenGywm.vue?vue&type=template&id=4d85aee1&scoped=true&"
import script from "./aboutCenGywm.vue?vue&type=script&lang=js&"
export * from "./aboutCenGywm.vue?vue&type=script&lang=js&"
import style1 from "./aboutCenGywm.vue?vue&type=style&index=1&id=4d85aee1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85aee1",
  null
  
)

export default component.exports